import { Component, OnInit, OnChanges, SimpleChanges,ViewEncapsulation,EventEmitter, ElementRef } from '@angular/core';
import * as d3 from 'd3';

import { D3ExampleDataService } from '../../services/d3-example-data.service';
import { ScatterPlotSamplePoint } from '../../services/ScatterPlotSamplePoint';

@Component({
  selector: 'app-scatter-plot-v4',
  templateUrl: './scatter-plot-v4.component.html',
  styleUrls: ['./scatter-plot-v4.component.scss']
})
// https://bl.ocks.org/Jverma/076377dd0125b1a508621441752735fc
export class ScatterPlotV4Component implements OnChanges, OnInit {
  
  
 

  private data: any;
  private margin: any = {top: 20, right: 20, bottom: 30, left: 40};
  private width: number;
  private height: any;
  private svg: any;
  private tooltip: any;
  private xScale: any;
  private yScale: any;
  private radius: any;
  private xAxis: any;
  private yAxis: any;
  private color: any;
  private bubble: any;
  private legend: any;

    constructor(private sampleData: D3ExampleDataService, private element:ElementRef) { }

  ngOnInit() {
    
    this.width = 800 - this.margin.left - this.margin.right,
    this.height = 400 - this.margin.top - this.margin.bottom;

    this.svg = d3.select(this.element.nativeElement).append('svg')
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

    this.tooltip = d3.select(this.element.nativeElement).append('div')
      .attr('class', 'tooltip')
      .style('opacity', 0);

    this.data = this.sampleData.RandomLearnMatrixSames(100);

    // Setup Scales
    this.xScale = d3.scaleLinear();
    this.xScale.range([0, this.width]);

    this.yScale = d3.scaleLinear()
      .range([this.height, 0]);

    this.radius = d3.scaleSqrt()
        .range([2, 5]);

    this.xAxis = d3.axisBottom(this.xScale);

    this.yAxis = d3.axisLeft(this.yScale);

    this.color = d3.scaleOrdinal(d3.schemeCategory10);

    this.updateChart();
  }

  updateChart(): void {

    const Scope = this;

    this.xScale.domain(d3.extent(this.data, function(d: ScatterPlotSamplePoint) {
			return d.UsefulnessLevel;
    })).nice();
    
    this.yScale.domain(d3.extent(this.data, function(d: ScatterPlotSamplePoint){
			return d.CommittmentLevel;
    })).nice();
    
    this.radius.domain(d3.extent(this.data, function(d: ScatterPlotSamplePoint){
			return d.CommittmentLevel * d.UsefulnessLevel;
    })).nice();
    
    this.svg.append('g')
			.attr('transform', 'translate(0,' + this.height + ')')
			.attr('class', 'x axis')
      .call(this.xAxis);
    
    this.svg.append('g')
			.attr('transform', 'translate(0,0)')
			.attr('class', 'y axis')
      .call(this.yAxis);

    this.bubble = this.svg.selectAll('.bubble')
			.data(this.data)
			.enter().append('circle')
			.attr('class', 'bubble')
			.attr('cx', (d) => {
        return this.xScale(d.UsefulnessLevel);
      })
			.attr('cy',(d) => {
        return this.yScale(d.CommittmentLevel);})
			.attr('r', (d) => {
        return this.radius(d.CommittmentLevel * d.UsefulnessLevel);
      })
			.style('fill', (d) => {
        return this.color(d.CommittmentLevel);
      });
    
      this.bubble.append('title')
        .attr('x', (d) => {
          return this.radius(d.CommittmentLevel); 
        })
        .text(function(d: ScatterPlotSamplePoint){
          return d.Name;
        });
      
      this.svg.append('text')
        .attr('x', 10)
        .attr('y', 10)
        .attr('class', 'label')
        .text('Commitment');

      this.svg.append('text')
        .attr('x', this.width)
        .attr('y', this.height - 10)
        .attr('text-anchor', 'end')
        .attr('class', 'label')
        .text('Usefulness');
      
      this.legend = this.svg.selectAll('legend')
        .data(this.color.domain())
        .enter().append('g')
        .attr('class', 'legend')
        .attr('transform', function(d, i){ return 'translate(0,' + i * 20 + ')'; });
      
      this.legend.append('rect')
        .attr('x', this.width)
        .attr('width', 18)
        .attr('height', 18)
        .style('fill', this.color);

      this.legend.append('text')
          .attr('x', this.width - 6)
          .attr('y', 9)
          .attr('dy', '.35em')
          .style('text-anchor', 'end')
          .text((d)=> { 
            return d.Name;
          });
        
      this.legend.on('click', function(type){
            d3.selectAll('.bubble')
              .style('opacity', 0.15)
              .filter(function(d: ScatterPlotSamplePoint){
                return d.CommittmentLevel === type;
              })
              .style('opacity', 1);
          });
       
      
  }
  /*
 GetTheX(d: ScatterPlotSamplePoint){
    return this.xScale(d.UsefulnessLevel);
  }
 GetTheY(d: ScatterPlotSamplePoint){
    return this.yScale(d.CommittmentLevel);
  }
  GetTheRadius(d: ScatterPlotSamplePoint) { 
    return this.radius(d.CommittmentLevel);
  }
  
  GetTheFill(d: ScatterPlotSamplePoint){
    return this.color(d.CommittmentLevel); 
  }
  */
  ngOnChanges(changes: SimpleChanges): void {

    //throw new Error('"Method not implemented.');

  }
}
